(function () {
  if (window.__frikiramaSocialShareInitialized) return;
  window.__frikiramaSocialShareInitialized = true;
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-frikirama-copy-url]');
    if (!button) return;
    var url = button.getAttribute('data-frikirama-copy-url') || '';
    if (!url) return;
    var feedback = button.closest('.frikirama-social-share').querySelector('[data-frikirama-copy-feedback]');
    var successful = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        successful = true;
      } else {
        var field = document.createElement('textarea');
        field.value = url;
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        successful = document.execCommand('copy');
        field.remove();
      }
    } catch (error) {
      successful = false;
    }
    if (feedback) feedback.textContent = successful ? '¡Enlace copiado!' : 'No se ha podido copiar el enlace.';
  });
})();
